import {createSlice} from '@reduxjs/toolkit';

export const initialState = {
    loading: true,
    subscriptionsList: [],
    subscription: null,
    success: false,
}

const subscriptionsSlice = createSlice({
    name: 'subscriptions',
    initialState,
    reducers: {
        getSubscriptionsList: (state, action) => {
            state.loading = true
        },
        subscriptionsSuccess: (state, action) => {
            state.subscriptionsList = action.payload
            state.loading = false
        },
        subscriptionsFailed: (state, action) => {
            state.loading = false
        },
        getSubscription: (state, action) => {
            state.loading = true
        },
        subscriptionSuccess: (state, action) => {
            state.subscription = action.payload
            state.loading = false
        },
        subscriptionFailed: (state, action) => {
            state.loading = false
            state.subscription = null
        },
        resetSubscription: (state, action) => {
            state.loading = false
            state.subscription = null
            state.success = false
        },
        activeSubscription: (state, action) => {},
        subscriptionActiveSuccessfully: (state, action) => {
            state.subscriptionsList = state.subscriptionsList.map((sub) => {
                if (sub.id === action.payload.id) {
                    return {...sub, status: 1}
                }
                return sub
            })
        },
        subscriptionActiveFailed: (state, action) => {},
        inactiveSubscription: (state, action) => {},
        subscriptionInactiveSuccessfully: (state, action) => {
            state.subscriptionsList = state.subscriptionsList.map((sub) => {
                if (sub.id === action.payload.id) {
                    return {...sub, status: 0}
                }
                return sub
            })
        },
        subscriptionInactiveFailed: (state, action) => {},
        renewSubscription: (state, action) => {},
        subscriptionRenewSuccessfully: (state, action) => {
            state.subscriptionsList = state.subscriptionsList.map((sub) => {
                if (sub.id === action.payload.id) {
                    return {...sub, status: 1}
                }
                return sub
            })
        },
        subscriptionRenewFailed: (state, action) => {},

        deleteSubscription: (state, action) => {},
        subscriptionDeletedSuccessfully: (state, action) => {
            state.subscriptionsList = state.subscriptionsList.filter((c) => c.id !== action.payload.id)
        },
        subscriptionDeletionFailed: (state, action) => {},

        sendSubscriptionPaymentLink: (state, action) => {},
        sendSubscriptionPaymentLinkSuccessfully: (state, action) => {},
        sendSubscriptionPaymentLinkFailed: (state, action) => {},
    }
})

export const {
    getSubscriptionsList,
    subscriptionsSuccess,
    subscriptionsFailed,
    getSubscription,
    subscriptionSuccess,
    subscriptionFailed,
    resetSubscription,
    activeSubscription,
    subscriptionActiveSuccessfully,
    subscriptionActiveFailed,
    inactiveSubscription,
    subscriptionInactiveSuccessfully,
    subscriptionInactiveFailed,
    renewSubscription,
    subscriptionRenewSuccessfully,
    subscriptionRenewFailed,
    deleteSubscription,
    subscriptionDeletedSuccessfully,
    subscriptionDeletionFailed,
    sendSubscriptionPaymentLink,
    sendSubscriptionPaymentLinkSuccessfully,
    sendSubscriptionPaymentLinkFailed,
} = subscriptionsSlice.actions;

export default subscriptionsSlice.reducer;
